/**
 * HHT2 TimeLine Contents 정보
 * @type {string[]}
 */

export const HHT2_EP7_ANSWERS = [
    'Holly finds a puppy in the garden!\n',
    'Holly brings it to the living room where Harry and Tony are watching TV.\n',
    'The kids want to keep the puppy for a day, but they need to ask Stephanie first.\n',
    'At first, Stephanie says they need to find the owners, but she lets the puppy stay because it is nighttime.\n',
    'When Stephanie calls Matt to tell him about the puppy, he is excited.\n',
    'Later, Harry makes a poster. It says the dog has “White and brown fur. Brown eyes.”\n',
    'Soon, the doorbell rings. Tony thinks it might be the owner.\n',
    'It’s Matt! He bought a big bag of dog food and lots of puppy things.\n',
    'Matt finally asks, “Where is the puppy?”\n',
    'Nobody can find the puppy!\n',
];

// export const HHT2_EP7_ANSWER_SOUNDS = [
//     '/HHT2_AB EP07_dyr01.mp3',
//     '/HHT2_AB EP07_dyr02.mp3',
//     '/HHT2_AB EP07_dyr03.mp3',
//     '/HHT2_AB EP07_dyr04.mp3',
//     '/HHT2_AB EP07_dyr05.mp3',
//     '/HHT2_AB EP07_dyr06.mp3',
//     '/HHT2_AB EP07_dyr07.mp3',
//     '/HHT2_AB EP07_dyr08.mp3',
//     '/HHT2_AB EP07_dyr09.mp3',
//     '/HHT2_AB EP07_dyr10.mp3',
// ];

export const HHT2_EP7_ANSWER_SOUNDS = [
    '/0cc59371da34581600ca5d587a4ca144.mp3',
    '/2632766acc5168dc365cc5f90afd6ece.mp3',
    '/1fe7c1c6c74fe8a27eb627ad8263ff34.mp3',
    '/3089bc788b2fe762005eda4a6778fd17.mp3',
    '/ab5fe744de3ccd7cb1258a35c04c1717.mp3',
    '/b4b2e18b21aae9ef86c12d9d9eef4677.mp3',
    '/f71592d101aa8b796fcee6baad334162.mp3',
    '/6deeca6f3a1a7e1b545a5a3e8f3f8670.mp3',
    '/e442c70b1ba8bc323fb4345bc5e6e3c0.mp3',
    '/638f043f4f628eca46781338f7b0df11.mp3',
];

export const HHT2_EP7_QUIZ_ITEMS = [{
    'A': HHT2_EP7_ANSWERS[8],
    'B': HHT2_EP7_ANSWERS[1],
    'SoundIndexA': 8,
    'SoundIndexB': 1,
    'answer': HHT2_EP7_ANSWERS[1],
    'sound': [2, 3],
    'exception': false,
},
    {
        'A': HHT2_EP7_ANSWERS[0],
        'B': HHT2_EP7_ANSWERS[4],
        'SoundIndexA': 0,
        'SoundIndexB': 4,
        'answer': HHT2_EP7_ANSWERS[4],
        'sound': [5, 6],
        'exception': false,
    },
    {
        'A': HHT2_EP7_ANSWERS[7],
        'B': HHT2_EP7_ANSWERS[2],
        'SoundIndexA': 7,
        'SoundIndexB': 2,
        'answer': HHT2_EP7_ANSWERS[7],
        'sound': [8],
        'exception': false,
    },
    {
        'A': HHT2_EP7_ANSWERS[9],
        'B': HHT2_EP7_ANSWERS[6],
        'SoundIndexA': 9,
        'SoundIndexB': 6,
        'answer': HHT2_EP7_ANSWERS[9],
        'sound': [9],
        'exception': false,
    },
]
